import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import { configureChart, generateSeries } from '@app/widgets/helpers/widget-helpers';

export const WhakaaweWaipaRiverNgaruawahia: BasicCartesianChartConfig = configureChart(
  'WHAKAAWE WHENUA - Land Use Impact: Waipa River / Ngāruawāhia bridge',
  generateSeries(['wrc_1191/6'], ['total-phosphorus', 'total-nitrogen'])
);

export const WaiWaipaRiverNgaruawahia: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling: Waipa River/Ngaruawahia Bridge',
  generateSeries(['wrc_1191/6'], ['ph-in-field', 'turbidity'])
);

export const WaterLevels: BasicCartesianChartConfig = configureChart(
  'Water Levels',
  generateSeries(['1293/11', '1293/15', '1131/91'], ['relative-water-level'], {
    type: 'bar',
    useDataSourceColours: true,
  })
);

export const WaiCablewayNgaruawahia: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Level - Ngāruawāhia Cableway',
  generateSeries(['wrc_1131_103'], ['flow', 'relative-water-level'])
);
